import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { ProgressSpinner } from 'primereact/progressspinner'
import BoxChart from '../../generals/boxCharts'
import Pie from '../../generals/charts/pie'
import KnobChart from '../../generals/charts/knob'
import VerticalBar from '../../generals/charts/verticalBar'
import stylesCardsInfo from '../../../css/generals/CardsInfo.module.css'
import BatteryChart from '../../generals/charts/battery'
import DevicesUseTimeChart from './DevicesUseTimeChart'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import { NavLink } from 'react-router-dom'
import { Avatar } from 'primereact/avatar'
import { Badge } from 'primereact/badge'
import { Tooltip } from 'primereact/tooltip'
import { useTranslation } from 'react-i18next'

export default function CardsStats ({ stat, preferences, connections, deviceUseTime, labelConn, role, dates, dateFilter, setDateFilter, id }) {
  const { t } = useTranslation('dashboardDevice')
  const badgeRefDisk = useRef(null)
  const badgeRefRam = useRef(null)
  const badgeRefBattery = useRef(null)

  const [quantity1Disk, setQuantity1Disk] = useState()
  const [quantity2Disk, setQuantity2Disk] = useState()
  const [quantity1Ram, setQuantity1Ram] = useState()
  const [quantity2Ram, setQuantity2Ram] = useState()
  const [quantity1Battery, setQuantity1Battery] = useState()
  const [quantity2Battery, setQuantity2Battery] = useState()

  useEffect(() => {
    if (stat) {
      setQuantity1Disk(stat.countOverDisk === null || stat.countOverDisk === 0 || stat.countOverDisk === undefined ? ' 0' : ` ${stat.countOverDisk}`)
      setQuantity2Disk(stat.countOverDisk === null || stat.countOverDisk === 0 || stat.countOverDisk === undefined ? ' 0' : stat.countOverDisk > 0 && stat.countOverDisk < 100 ? ` ${stat.countOverDisk}` : ' +99')
      setQuantity1Ram(stat.countOverRam === null || stat.countOverRam === 0 || stat.countOverRam === undefined ? ' 0' : ` ${stat.countOverRam}`)
      setQuantity2Ram(stat.countOverRam === null || stat.countOverRam === 0 || stat.countOverRam === undefined ? ' 0' : stat.countOverRam > 0 && stat.countOverRam < 100 ? ` ${stat.countOverRam}` : ' +99')
      setQuantity1Battery(stat.countOverBattery === null || stat.countOverBattery === 0 || stat.countOverBattery === undefined ? ' 0' : ` ${stat.countOverBattery}`)
      setQuantity2Battery(stat.countOverBattery === null || stat.countOverBattery === 0 || stat.countOverBattery === undefined ? ' 0' : stat.countOverBattery > 0 && stat.countOverBattery < 100 ? ` ${stat.countOverBattery}` : ' +99')
    }
  }, [stat])

  return (
        <div className={stylesCardsInfo.cardsContainer}>
            {role?.dashboardDevicePage.diskChartDashboardDevice && <BoxChart
              title={t('cardsStats.title1')}
              icon="fa-solid fa-floppy-disk"
              className={`${stylesCardsInfo.boxChart}`}>
              { stat === undefined
                ? (
                <ProgressSpinner />
                  )
                : stat?.error || stat?.percentageDisk === null
                  ? (
                <h5>{t('cardsStats.label1')}</h5>
                    )
                  : (
                <div className={stylesCardsInfo.containerBoxChart}>
                  {preferences?.preferencesReport.overAlert && <div className={stylesCardsInfo.alertContainer}>
                    <Tooltip target={badgeRefDisk} content={`${t('cardsStats.label2')} ${quantity1Disk} ${t('cardsStats.label3')}`} mouseTrack mouseTrackLeft={10} />
                    <Avatar className="p-overlay-badge" icon="pi pi-bell" shape="circle">
                      <span ref={badgeRefDisk}>
                        <Badge className="badge" severity="danger" value={quantity2Disk}/>
                      </span>
                    </Avatar>
                  </div>}
                  <Pie
                    type={'individual'}
                    data={stat}
                  />
                </div>)}
            </BoxChart>}
            {role?.dashboardDevicePage.ramChartDashboardDevice && <BoxChart
              title={t('cardsStats.title2')}
              icon="fa-solid fa-memory"
              className={`${stylesCardsInfo.boxChart}`}
            >
              {stat === undefined
                ? (
                <ProgressSpinner />
                  )
                : preferences === undefined
                  ? (
                <ProgressSpinner />
                    )
                  : stat?.error || preferences?.error || stat.percentageRam === null
                    ? (
                <h5>{t('cardsStats.label1')}</h5>
                      )
                    : (
                <div className={stylesCardsInfo.containerBoxChart}>
                  {preferences?.preferencesReport.overAlert && <div className={stylesCardsInfo.alertContainer}>
                    <Tooltip target={badgeRefRam} content={`${t('cardsStats.label2')} ${quantity1Ram} ${t('cardsStats.label3')}`} mouseTrack mouseTrackLeft={10} />
                    <Avatar className="p-overlay-badge" icon="pi pi-bell" shape="circle">
                      <span ref={badgeRefRam}>
                        <Badge className="badge" severity="danger" value={quantity2Ram}/>
                      </span>
                    </Avatar>
                  </div>}
                  <KnobChart
                    data={stat}
                    alert={preferences.preferencesReport.percentRam}
                    type="individual"
                    size={230}
                  />
                </div>)}
            </BoxChart>}
            {role?.dashboardDevicePage.battery && <BoxChart
              title={t('cardsStats.title3')}
              icon="fas fa-battery-full"
              className={`${stylesCardsInfo.boxChart}`}
            >
              { stat === undefined
                ? (
                <ProgressSpinner />
                  )
                : stat?.error || stat?.Battery === undefined || isNaN(parseInt(stat?.Battery?.lifePercent))
                  ? (
                <h5>{t('cardsStats.label1')}</h5>
                    )
                  : (
                    <div className={stylesCardsInfo.batteryContainer}>
                      {preferences?.preferencesReport.overAlert && <div className={stylesCardsInfo.alertContainer}>
                        <Tooltip target={badgeRefBattery} content={`${t('cardsStats.label2')} ${quantity1Battery} ${t('cardsStats.label3')}`} mouseTrack mouseTrackLeft={10} />
                        <Avatar className="p-overlay-badge" icon="pi pi-bell" shape="circle">
                          <span ref={badgeRefBattery}>
                            <Badge className="badge" severity="danger" value={quantity2Battery}/>
                          </span>
                        </Avatar>
                      </div>}
                      <BatteryChart
                        role={role}
                        statBattery={stat?.Battery}
                      />
                    </div>)}
            </BoxChart>}
            {role?.dashboardDevicePage.connectionsVerticalBar && <BoxChart
              title={t('cardsStats.title4')}
              icon="fa-solid fa-mobile"
              className={`${stylesCardsInfo.boxChart}`}
            >
              {connections === undefined
                ? (
                <ProgressSpinner />
                  )
                : connections?.error || connections.length === 0
                  ? (
                <h5>{t('cardsStats.label1')}</h5>
                    )
                  : labelConn
                    ? (<div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: 'auto',
                            alignItems: 'center',
                            position: 'relative'
                          }}
                      >
                        {role?.dashboardDevicePage.moreConnectionsButton && <NavLink
                          to={`/mdm/connections-history/${id}`}
                          className={`btn btn-dark ${stylesCardsInfo.navLinkLastLocation}`}
                          type="button"
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth'
                            })
                          }}
                        >
                          <i className="pi pi-map-marker" style={{ marginRight: '0.5rem' }}></i>
                          {t('cardsStats.title4')}
                        </NavLink>}
                        <VerticalBar
                          data={labelConn.data}
                          labels={labelConn.labels}
                          backgroundColor={labelConn.backgroundColor}
                          title={t('cardsStats.title4')}
                        />
                      </div>)
                    : (<></>)}
            </BoxChart>}
            {role?.dashboardDevicePage.devicesUseTimeChart && <BoxChart
              title={t('cardsStats.title5')}
              icon="fa-solid fa-mobile"
              className={`${stylesCardsInfo.boxChart}`}
            >
              <ButtonGroup className={stylesCardsInfo.dateFilterContainer}>
                {dates.map((date, index) => (
                  <ToggleButton
                    key={index}
                    id={`date-home-${index}`}
                    type="radio"
                    variant="secondary"
                    name="date-home"
                    value={date.value}
                    checked={date.value === dateFilter}
                    className={stylesCardsInfo.btnDateUseTimeApps}
                    onChange={(e) => setDateFilter(parseInt(e.target.value))}
                  >
                    {date.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
              {deviceUseTime === undefined
                ? (
                <ProgressSpinner />
                  )
                : deviceUseTime?.error || deviceUseTime?.useTime === 0
                  ? (
                <h5>{t('cardsStats.label1')}</h5>
                    )
                  : (<DevicesUseTimeChart
                      data={deviceUseTime}
                      filter={dateFilter}
                  />)}
            </BoxChart>}
        </div>
  )
}

CardsStats.propTypes = {
  stat: PropTypes.object,
  preferences: PropTypes.object,
  connections: PropTypes.array,
  labelConn: PropTypes.object,
  role: PropTypes.object,
  deviceUseTime: PropTypes.object,
  dates: PropTypes.array,
  dateFilter: PropTypes.number,
  setDateFilter: PropTypes.func,
  id: PropTypes.number
}
